module.exports = __webpack_public_path__ + "img/horizontal_6_5_8011.34a08c60.png";